import { render, staticRenderFns } from "./SimpleDropdown.vue?vue&type=template&id=05d46e1f"
import script from "./SimpleDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleDropdown.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports